import L from 'leaflet';
import 'leaflet-draw';

const dl = (L.drawLocal = L.drawLocal || {});
dl.draw = dl.draw || {};
dl.draw.toolbar = dl.draw.toolbar || {};
dl.draw.toolbar.actions = dl.draw.toolbar.actions || {};
dl.draw.toolbar.finish = dl.draw.toolbar.finish || {};
dl.draw.toolbar.undo = dl.draw.toolbar.undo || {};
dl.draw.toolbar.buttons = dl.draw.toolbar.buttons || {};
dl.draw.handlers = dl.draw.handlers || {};
dl.draw.handlers.circle = dl.draw.handlers.circle || { tooltip: {} };
dl.draw.handlers.circle.tooltip = dl.draw.handlers.circle.tooltip || {};
dl.draw.handlers.marker = dl.draw.handlers.marker || { tooltip: {} };
dl.draw.handlers.marker.tooltip = dl.draw.handlers.marker.tooltip || {};
dl.draw.handlers.polygon = dl.draw.handlers.polygon || { tooltip: {} };
dl.draw.handlers.polygon.tooltip = dl.draw.handlers.polygon.tooltip || {};
dl.draw.handlers.polyline = dl.draw.handlers.polyline || { tooltip: {} };
dl.draw.handlers.polyline.tooltip = dl.draw.handlers.polyline.tooltip || {};
dl.draw.handlers.rectangle = dl.draw.handlers.rectangle || { tooltip: {} };
dl.draw.handlers.rectangle.tooltip = dl.draw.handlers.rectangle.tooltip || {};
dl.draw.handlers.circlemarker = dl.draw.handlers.circlemarker || { tooltip: {} };
dl.draw.handlers.circlemarker.tooltip = dl.draw.handlers.circlemarker.tooltip || {};

dl.edit = dl.edit || {};
dl.edit.toolbar = dl.edit.toolbar || {};
dl.edit.toolbar.actions = dl.edit.toolbar.actions || {};
dl.edit.toolbar.actions.save = dl.edit.toolbar.actions.save || {};
dl.edit.toolbar.actions.cancel = dl.edit.toolbar.actions.cancel || {};
dl.edit.toolbar.actions.clearAll = dl.edit.toolbar.actions.clearAll || {};
dl.edit.toolbar.buttons = dl.edit.toolbar.buttons || {};
dl.edit.handlers = dl.edit.handlers || {};
dl.edit.handlers.edit = dl.edit.handlers.edit || { tooltip: {} };
dl.edit.handlers.edit.tooltip = dl.edit.handlers.edit.tooltip || {};
dl.edit.handlers.remove = dl.edit.handlers.remove || { tooltip: {} };
dl.edit.handlers.remove.tooltip = dl.edit.handlers.remove.tooltip || {};

dl.draw.toolbar.actions.title = 'Cancelar dibujo';
dl.draw.toolbar.actions.text = 'Cancelar';
dl.draw.toolbar.finish.title = 'Finalizar dibujo';
dl.draw.toolbar.finish.text = 'Finalizar';
dl.draw.toolbar.undo.title = 'Eliminar el último punto';
dl.draw.toolbar.undo.text = 'Deshacer';
dl.draw.toolbar.buttons.polyline = 'Dibujar polilínea';
dl.draw.toolbar.buttons.polygon = 'Dibujar polígono';
dl.draw.toolbar.buttons.rectangle = 'Dibujar rectángulo';
dl.draw.toolbar.buttons.circle = 'Dibujar círculo';
dl.draw.toolbar.buttons.marker = 'Añadir marcador';
dl.draw.toolbar.buttons.circlemarker = 'Añadir marcador circular';

dl.draw.handlers.circle.tooltip.start = 'Haz clic y arrastra para dibujar el círculo.';
dl.draw.handlers.circle.radius = 'Radio';
dl.draw.handlers.marker.tooltip.start = 'Haz clic en el mapa para colocar un marcador.';
dl.draw.handlers.polygon.tooltip.start = 'Haz clic para empezar a dibujar la forma.';
dl.draw.handlers.polygon.tooltip.cont = 'Haz clic para continuar dibujando.';
dl.draw.handlers.polygon.tooltip.end = 'Haz clic en el primer punto para cerrar la forma.';
dl.draw.handlers.polyline.tooltip.start = 'Haz clic para empezar una línea.';
dl.draw.handlers.polyline.tooltip.cont = 'Haz clic para continuar la línea.';
dl.draw.handlers.polyline.tooltip.end = 'Haz clic en el último punto para finalizar.';
dl.draw.handlers.rectangle.tooltip.start = 'Haz clic y arrastra para dibujar el rectángulo.';
dl.draw.handlers.circlemarker.tooltip.start = 'Haz clic para colocar el marcador circular.';

dl.edit.toolbar.actions.save.title = 'Guardar cambios';
dl.edit.toolbar.actions.save.text = 'Guardar';
dl.edit.toolbar.actions.cancel.title = 'Cancelar edición y descartar cambios';
dl.edit.toolbar.actions.cancel.text = 'Cancelar';
dl.edit.toolbar.actions.clearAll.title = 'Eliminar todas las capas';
dl.edit.toolbar.actions.clearAll.text = 'Eliminar todo';
dl.edit.toolbar.buttons.edit = 'Editar capas';
dl.edit.toolbar.buttons.editDisabled = 'No hay capas para editar';
dl.edit.toolbar.buttons.remove = 'Eliminar capas';
dl.edit.toolbar.buttons.removeDisabled = 'No hay capas para eliminar';
dl.edit.handlers.edit.tooltip.text = 'Arrastra los manejadores para editar la forma.';
dl.edit.handlers.edit.tooltip.subtext = 'Haz clic en “Guardar” para aplicar los cambios.';
dl.edit.handlers.remove.tooltip.text = 'Haz clic en una forma para eliminarla.';
dl.edit.handlers.remove.tooltip.subtext = 'Haz clic en “Guardar” para confirmar.';
